<script setup lang="ts">
/**
 * The template's dark "integrations" block: a cluster of round white icon tiles
 * on one side, a headline, a paragraph and one button on the other. Here the
 * tiles are the channels a single CV can go out through.
 */
const { t } = useI18n()

const channels = [
  { id: 'coverLetter', icon: 'bi-envelope-paper', to: '/ai-cover-letter' },
  { id: 'pdf', icon: 'bi-file-earmark-pdf', to: '/templates' },
  { id: 'link', icon: 'bi-link-45deg', to: '/online-cv' },
  { id: 'qr', icon: 'bi-qr-code', to: '/online-cv' },
  { id: 'ats', icon: 'bi-shield-check', to: '/ats-check' },
  { id: 'languages', icon: 'bi-translate', to: '/cv-languages' },
] as const
</script>

<template>
  <section class="sofax bg-ink dark:bg-gray-900">
    <div class="section-space">
      <div class="shell">
        <div class="grid grid-cols-1 items-center gap-16 xl:grid-cols-2 xl:gap-20">
          <!-- Icon cluster: two staggered rows, as in the template -->
          <ul class="order-2 mx-auto grid max-w-md grid-cols-3 gap-6 sm:gap-7 xl:order-1">
            <li v-for="channel in channels" :key="channel.id" class="flex justify-center">
              <LocaleLink
                :to="channel.to"
                :title="t(`homepage.integration.channels.${channel.id}`)"
                class="group flex size-[5.75rem] flex-col items-center justify-center gap-1 rounded-full bg-white text-ink transition-transform duration-300 hover:-translate-y-1 hover:text-accent"
              >
                <i :class="['bi', channel.icon, 'text-3xl']" />
                <span class="sr-only">{{ t(`homepage.integration.channels.${channel.id}`) }}</span>
              </LocaleLink>
            </li>
          </ul>

          <div class="order-1 mx-auto max-w-2xl text-center xl:order-2 xl:text-left">
            <h2 class="mb-5 !text-white">{{ t('homepage.integration.title') }}</h2>
            <p class="mb-10 text-lg !text-white/75 md:mb-12">{{ t('homepage.integration.text') }}</p>
            <SofaxBtn to="/online-cv" :label="t('homepage.integration.cta')" variant="accent" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
